var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    rx: 12,
    fill: "#DC4E4E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1127_6576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 6.75748L23.2739 6L16.5478 13.0166C15.707 13.8937 14.293 13.8937 13.4522 13.0166L6.72612 6.03987L6 6.79734L11.0064 12.0199L6 17.2425L6.72612 18L11.7325 12.7774L12.7261 13.814C13.3376 14.4518 14.1401 14.8106 14.9809 14.8106C15.8217 14.8106 16.6242 14.4518 17.2357 13.814L18.2293 12.7774L23.2357 18L23.9618 17.2425L18.9554 12.0199L24 6.75748Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4474 18.9157H7.58076C6.7151 18.9157 6 18.2006 6 17.335V6.72132C6 5.85567 6.7151 5.14056 7.58076 5.14056H22.4474C23.313 5.14056 24.0281 5.85567 24.0281 6.72132V17.335C24.0281 18.2006 23.313 18.9157 22.4474 18.9157ZM7.54312 6.15676C7.24202 6.15676 7.0162 6.38258 7.0162 6.68368V17.2973C7.0162 17.5984 7.24202 17.8242 7.54312 17.8242H22.4097C22.7108 17.8242 22.9367 17.5984 22.9367 17.2973V6.68368C22.9367 6.38258 22.7108 6.15676 22.4097 6.15676H7.54312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1127_6576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.da7877be3fe0ab99d91125f6883342cc.svg";
export { ForwardRef as ReactComponent };